module.exports = __webpack_public_path__ + "img/ai-search-5.65c96a28.jpg";